module.exports = __webpack_public_path__ + "img/icon_familly.6206b0aa.svg";